"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var menu_item_1 = require("../../model/menu-item");
var router_1 = require("@angular/router");
var LayoutScopeComponent = /** @class */ (function () {
    function LayoutScopeComponent(_router) {
        this._router = _router;
        this.createNavBarMenu();
    }
    LayoutScopeComponent.prototype.ngOnInit = function () {
        if (this._router.url === '/') {
            this._router.navigate(['attendings', 'list']);
        }
    };
    LayoutScopeComponent.prototype.createNavBarMenu = function () {
        var item = new menu_item_1.MenuItem('Notificações', '/notifications', 'white chip tx-text-light', 'fa-bell');
        this._myMenu = new Array();
        this._myMenu.push(item);
    };
    LayoutScopeComponent.ctorParameters = function () { return [{ type: router_1.Router }]; };
    return LayoutScopeComponent;
}());
exports.LayoutScopeComponent = LayoutScopeComponent;
//# sourceMappingURL=layout-scope.component.js.map


// WEBPACK FOOTER //
// layout-scope.component.js